import type { Job } from './types'

/** Return the newest retryable capture for one source, regardless of global job pagination. */
export function latestFailedCapture(jobs: Job[], sourceId: string) {
  return jobs
    .filter((job) => job.source_id === sourceId && job.kind === 'capture' && (job.status === 'failed' || job.status === 'interrupted'))
    .sort((left, right) => right.created_at.localeCompare(left.created_at))[0] || null
}

type CaptureRetryClient = {
  jobs: (sourceId: string) => Promise<Job[]>
  retryJob: (id: string) => Promise<Job>
}

/** Retry a source's newest failed capture, found through its source-scoped job list. */
export async function retryLatestCapture(client: CaptureRetryClient, sourceId: string) {
  const job = latestFailedCapture(await client.jobs(sourceId), sourceId)
  if (!job) throw new Error('No failed capture is available to retry. Connect the stream again.')
  return client.retryJob(job.id)
}
